import axios from "axios";

import { GENERAL_URL_API } from "../../../urls";

/**
 * @param {string} id - id del notibanner a eliminar
 * @returns {Promise<{info: string, status: boolean}>}
 */
export async function eliminarNotibanner(id) {
  const fd = new FormData();
  fd.append("idNotibanner", id);

  const { data } = await axios.post(
    `${GENERAL_URL_API}/notificaciones/notibanner/borrarNotibanner`,
    fd,
    {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return data;
}
